import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home/index.vue'
import jie from '@/views/HomeOne/index.vue'
import Echarer from '@/views/Echarer/index.vue'
Vue.use(VueRouter)

const CanYinReport=()=>import('@/Report/CanYinReport/CanYinReport.vue')  //新的餐饮报表
const DetailsRanking=()=>import('@/Report/DetailsRanking/DetailsRanking.vue')  //排行榜
const Productionquantity=()=>import('@/Report/Productionquantity/Productionquantity.vue')  //生产详情

const SortingDetails=()=>import('@/Report/SortingDetails/SortingDetails.vue')  //分拣详情
const Detailsproducts=()=>import('@/Report/Detailsproducts/Detailsproducts.vue')  //半成品加工详情

const DetailedGeneration=()=>import('@/Report/DetailedGeneration/DetailedGeneration.vue')  //详细生产分析

const ChefDetails=()=>import('@/Report/ChefDetails/ChefDetails.vue')  //厨师生产详情
const SalesAnalysis=()=>import('@/Report/SalesAnalysis/SalesAnalysis.vue')  //详情销售分析
const SalesAnalysisMap=()=>import('@/Report/SalesAnalysis/SalesAnalysisMap.vue')  //详情销售分析 横屏

const InventoryDetails=()=>import('@/Report/InventoryDetails/InventoryDetails.vue')  //原材料库存详情

const Reportinglosses=()=>import('@/Report/Reportinglosses/Reportinglosses.vue')  //原材料报损详情
const PurchasingGoods=()=>import('@/Report/PurchasingGoods/PurchasingGoods.vue')  //采购商品详情
const PurchasingGoodsMap=()=>import('@/Report/PurchasingGoods/PurchasingGoodsMap.vue')  //采购商品详情 折线图
const stocktakingDatils=()=>import('@/Report/stocktakingDatils/stocktakingDatils.vue')  //盘点详情
const DetailsOfDishes=()=>import('@/Report/DetailsOfDishes/DetailsOfDishes.vue')  //菜品详情

const Salesvolumedishes=()=>import('@/Report/Salesvolumedishes/Salesvolumedishes.vue')  //菜品销量明细
const SalesvolumedishesMap=()=>import('@/Report/Salesvolumedishes/SalesvolumedishesMap.vue')  //菜品销量明细 横屏


const Returningdishes=()=>import('@/Report/Returningdishes/Returningdishes.vue')  //菜品退菜明细
const ReturningdishesMap=()=>import('@/Report/Returningdishes/ReturningdishesMap.vue')  //菜品退菜明细横屏


const SelloffDetails=()=>import('@/Report/SelloffDetails/SelloffDetails.vue')  //菜品沽清明细
const StoreDetails=()=>import('@/Report/StoreDetails/StoreDetails.vue')  //门店详情
const InventoryMap=()=>import('@/Report/InventoryMap/InventoryMap.vue')  //库存量趋势（近14天）

const DineinService=()=>import('@/Report/DineinService/DineinService.vue')  //堂食明细
const DiningDetails=()=>import('@/Report/DineinService/DiningDetails.vue')  //堂食明细详情

const SelfPickup=()=>import('@/Report/SelfPickup/SelfPickup.vue')  //自提明细
const SelfPickupDetils=()=>import('@/Report/SelfPickup/SelfPickupDetils.vue')  //自提明细详情

const RetailText=()=>import('@/Report/RetailText/RetailText.vue')  //自提明细
const RetailTextDetils=()=>import('@/Report/RetailText/RetailTextDetils.vue')  //自提明细详情

const OtherReceipts=()=>import('@/Report/OtherReceipts/OtherReceipts.vue')  //自提明细
const OtherReceiptsDetils=()=>import('@/Report/OtherReceipts/OtherReceiptsDetils.vue')  //自提明细详情

const Salescompletionrate=()=>import('@/Report/Salescompletionrate/Salescompletionrate.vue')  //菜品销售完成率

const BusinessDaily=()=>import('@/Report/BusinessDaily/BusinessDaily.vue')  //经营日报

const BusinessDailytype=()=>import('@/Report/BusinessDaily/BusinessDailytype.vue')  //门店经营日报
const Inventorysurplus=()=>import('@/Report/BusinessDaily/Inventorysurplus.vue')  //盘盈盘亏明细

const EnterdaysMap=()=>import('@/Report/BusinessDaily/EnterdaysMap.vue')  //近10天趋势图
const enInventoryDetails=()=>import('@/Report/BusinessDaily/enInventoryDetails.vue')  //库存明细
const Grossprofitranking=()=>import('@/Report/BusinessDaily/Grossprofitranking.vue')  //毛利排行明细




const IncomeTrendChart=()=>import('@/Report/IncomeTrendChart/IncomeTrendChart.vue')  //收入趋势图
const GenerateDailyreport=()=>import('@/Report/GenerateDailyreport/GenerateDailyreport.vue')  //生成日报
const GenerateDailyone=()=>import('@/Report/GenerateDailyreport/GenerateDailyone.vue')  //库存明细


const stocktakingDetils=()=>import('@/Report/GenerateDailyreport/stocktakingDetils.vue')  //分拣半成品盘点

const ManagementException=()=>import('@/Report/ManagementException/ManagementException.vue')  //管理异常日报

const MarketingDaily=()=>import('@/Report/MarketingDaily/MarketingDaily.vue')  //营销日报



const routes = [
  {
    path: '/CanYinReport',
    component:CanYinReport,
    meta: {
       title:'报表',
       keepAlive: true, //此组件需要被缓存
      //  isBack: false, //用于判断上一个页面是哪个

     }            
  
  },
  {
    path: '/DetailsRanking',
    component:DetailsRanking,
    meta: { title:'排行榜' }            
  
  },
  {
    path: '/Productionquantity',
    component:Productionquantity,
    meta: { title:'生产详情' }            
  
  },
  {
    path: '/SortingDetails',
    component:SortingDetails,
    meta: { title:'分拣详情' }            
  
  },
  {
    path: '/Detailsproducts',
    component:Detailsproducts,
    meta: { title:'半成品加工详情' }            
  
  },
  {
    path: '/DetailedGeneration',
    component:DetailedGeneration,
    meta: { title:'详细生产分析' ,
      keepAlive: true, //此组件需要被缓存
    }            
  
  },
  {
    path: '/ChefDetails',
    component:ChefDetails,
    meta: { title:'厨师生产详情' }            
  
  },
  {
    path: '/SalesAnalysis',
    component:SalesAnalysis,
    meta: { 
      title:'详情销售分析',
      keepAlive: true, //此组件需要被缓存
     }            
  
  },
  {
    path: '/SalesAnalysisMap',
    component:SalesAnalysisMap,
    meta: { 
      title:'销售分类',
      keepAlive: true, //此组件需要被缓存
     }            
  
  },
  
  {
    path: '/InventoryDetails',
    component:InventoryDetails,
    meta: { title:'原材料库存详情',
      keepAlive: true, //此组件需要被缓存
     }            
  
  },
  {
    path: '/Reportinglosses',
    component:Reportinglosses,
    meta: { title:'原材料报损详情' }            
  
  },
  {
    path: '/PurchasingGoods',
    component:PurchasingGoods,
    meta: { title:'采购商品详情',
      keepAlive: true, //此组件需要被缓存
     }            
  
  },
  {
    path: '/PurchasingGoodsMap',
    component:PurchasingGoodsMap,
    meta: { title:'采购趋势(近14天)', 
      keepAlive: true, //此组件需要被缓存

    }            
  
  },
  
  {
    path: '/stocktakingDatils',
    component:stocktakingDatils,
    meta: { title:'主料/辅料盘点详情' }            
  
  },
  {
    path: '/DetailsOfDishes',
    component:DetailsOfDishes,
    meta: { title:'菜品详情' }            
  
  },
  {
    path: '/Salesvolumedishes',
    component:Salesvolumedishes,
    meta: { title:'菜品销量明细' }            
  
  },
  {
    path: '/SalesvolumedishesMap',
    component:SalesvolumedishesMap,
    meta: { title:'菜品销量明细',
      keepAlive: true, //此组件需要被缓存
    }            
  
  },
  
  {
    path: '/Returningdishes',
    component:Returningdishes,
    meta: { title:'菜品退菜明细' }            
  
  },
  {
    path: '/ReturningdishesMap',
    component:ReturningdishesMap,
    meta: { title:'菜品退菜明细',
      keepAlive: true, //此组件需要被缓存
     }            
  
  },
  
  {
    path: '/SelloffDetails',
    component:SelloffDetails,
    meta: { title:'菜品沽清明细' }            
  
  },
  {
    path: '/StoreDetails',
    component:StoreDetails,
    meta: { title:'门店详情' }            
  
  },
  {
    path: '/InventoryMap',
    component:InventoryMap,
    meta: { title:'库存量趋势（近14天）',
      keepAlive: true, //此组件需要被缓存

     }            
  
  },
  {
    path: '/DineinService',
    component:DineinService,
    meta: { title:'堂食明细' }            
  
  },
  {
    path: '/DiningDetails',
    component:DiningDetails,
    meta: { title:'详情' }            
  
  },
  {
    path: '/SelfPickup',
    component:SelfPickup,
    meta: { title:'自提明细' }            
  
  },
  {
    path: '/SelfPickupDetils',
    component:SelfPickupDetils,
    meta: { title:'详情' }            
  
  },
  {
    path: '/RetailText',
    component:RetailText,
    meta: { title:'零售明细' }            
  
  },
  {
    path: '/RetailTextDetils',
    component:RetailTextDetils,
    meta: { title:'详情' }            
  
  },
  {
    path: '/OtherReceipts',
    component:OtherReceipts,
    meta: { title:'其他收款' }            
  
  },
  {
    path: '/OtherReceiptsDetils',
    component:OtherReceiptsDetils,
    meta: { title:'详情' }            
  
  },
  {
    path: '/Salescompletionrate',
    component:Salescompletionrate,
    meta: { title:'菜品销售完成率详情' }            
  
  },
  {
    path: '/BusinessDaily',
    component:BusinessDaily,
    meta: { title:'经营日报',
          isBack: false, //用于判断上一个页面是哪个
          keepAlive: true, //此组件需要被缓存
     }            
  
  },
  {
    path: '/BusinessDailytype',
    component:BusinessDailytype,
    meta: { title:'经营日报',
      keepAlive: true, //此组件需要被缓存
    
     }            
  
  },
  {
    path: '/Inventorysurplus',
    component:Inventorysurplus,
    meta: { title:'主料/辅料盘点盈亏明细' }            
  
  },
  {
    path: '/EnterdaysMap',
    component:EnterdaysMap,
    meta: { title:'近10天趋势图',
      keepAlive: true, //此组件需要被缓存
     }            
  
  },
  {
    path: '/enInventoryDetails',
    component:enInventoryDetails,
    meta: { title:'库存明细',
   
     }
  },     
  {
    path: '/Grossprofitranking',
    component:Grossprofitranking,
    meta: { title:'毛利排行',
   
     }
  },     
  
  {
      path: '/IncomeTrendChart',
      component:IncomeTrendChart,
      meta: { title:'收入趋势',
        keepAlive: true, //此组件需要被缓存
       }       
  },
  {
    path: '/GenerateDailyreport',
    component:GenerateDailyreport,
    meta: { title:'生产日报',
      keepAlive: true, //此组件需要被缓存
     }       
  },
  {
    path: '/stocktakingDetils',
    component:stocktakingDetils,
    meta: { title:'盘点',
     
     }       
  },
  {
    path: '/ManagementException',
    component:ManagementException,
    meta: { title:'管理异常日报',
     
     }       
  },
  {
    path: '/GenerateDailyone',
    component:GenerateDailyone,
    meta: { title:'生产日报',
      keepAlive: true, //此组件需要被缓存
     
     }       
  },
  {
    path: '/MarketingDaily',
    component:MarketingDaily,
    meta: { title:'营销日报',
    
     
     }       
  },
  
  
  
  
  
  
  
  
  
  
  
  
    
  
  
  







  

  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: "汤富贵经营分析"
    }
  },
  {
    path: '/jie',
    name: 'jie',
    component: jie,
    meta: {
      title: "汤富贵结班表"
    }
  },
  {
    path: '/Echarer',
    name: "Echarer",
    component: Echarer,
  },
  {
    path: "/duo",
    name: "duo",
    component: () => import('@/views/duo/index.vue'),
  },
  {
    path: '/da',
    name: "da",
    component: () => import('@/components/tup/index.vue'),
  },
  {
    path: "/chefSort",
    name: "/chefSort",
    component: () => import('@/views/chefSort/index.vue'),
    meta: {
      title: "详细生产数据分析详情"
    }
  },
  {
    path: "/vari",
    name: "variety",
    component: () => import('@/components/not/index.vue'),
  },
  {
    path: "/sale",
    name: "sale",
    component: () => import('@/views/sale/index.vue'),
    meta: {
      title: "详细销售分析"
    }
  },
  {
    path: "/chefHome",
    name: "chefHome",
    component: () => import('@/views/chefHome/index.vue'),
    meta: {
      title: "详细生产数据分析"
    }
  },
  {
    path: "/store",
    name: "store",
    component: () => import("../views/storeData/index.vue"),
  },
  {
    path: "/task",
    name: "task",
    component: () => import("@/views/Task/index.vue"),
  },
  {
    path: "/stores",
    name: "stores",
    meta: {
      title: "汤富贵门店列表"
    },
    component: () => import("../views/sotre/index.vue"),
  },
  {
    path:"/pcHome",
    name:"/pcHome",
    meta: {
      title: "汤富贵"
    },
    component:()=>import('../views/PcHome/index.vue'),
  },
  {
    path:"/",
    name:"/pcHome",
    meta: {
      title: "汤富贵"
    },
    component:()=>import('../views/PcHome/index.vue'),
  }
  // {
  //   path:"/StoreDataTow",
  //   name:"StoreData",
  //   component:()=>import('@/components/StoreDataOne/index.vue'),
  // },
  // {
  //   path:"/StoreDataThree",
  //   name:"StoreData",
  //   component:()=>import('@/components/StoreDataThree/index.vue'),
  // },
  // {
  //   path:"/StoreDataFrom",
  //   name:"StoreData",
  //   component:()=>import('@/components/StoreDataTow/index.vue'),
  // }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title);
  next()


document.body.scrollTop = 0;
document.documentElement.scrollTop = 0;
window.pageYOffset = 0;
  next()

})
export default router
